import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withCtx as _withCtx, createElementVNode as _createElementVNode, vShow as _vShow, normalizeStyle as _normalizeStyle, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = {
  key: 0
};
const _hoisted_2 = ["src"];
const _hoisted_3 = {
  key: 0
};
const _hoisted_4 = {
  key: 0
};
const _hoisted_5 = {
  key: 0
};
const _hoisted_6 = {
  key: 0
};
const _hoisted_7 = {
  key: 0
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_vxe_column = _resolveComponent("vxe-column");
  const _component_vxe_input = _resolveComponent("vxe-input");
  const _component_el_image = _resolveComponent("el-image");
  const _component_el_icon = _resolveComponent("el-icon");
  const _component_el_upload = _resolveComponent("el-upload");
  const _component_vxe_table = _resolveComponent("vxe-table");
  return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_vxe_table, {
    id: "bzuxtable",
    onCheckboxChange: _ctx.selectionChange,
    onCheckboxAll: _ctx.selectAllChange,
    "max-height": "400",
    "checkbox-config": {
      checkRowKeys: _ctx.selectlist
    },
    "row-config": {
      keyField: 'id'
    },
    "custom-config": {
      storage: true
    },
    border: "",
    "show-overflow": "",
    data: _ctx.bzyxTableData,
    "column-config": {
      resizable: true
    },
    "edit-config": {
      trigger: 'click',
      mode: 'cell',
      showUpdateStatus: true,
      showInsertStatus: true
    },
    class: "ggdycss"
  }, {
    default: _withCtx(() => [_createVNode(_component_vxe_column, {
      type: "checkbox",
      width: "50",
      align: "center"
    }), _createVNode(_component_vxe_column, {
      field: "name",
      title: "盒型选择",
      "edit-render": {
        autofocus: '.vxe-input--inner'
      },
      width: "140",
      align: "left"
    }, {
      edit: _withCtx(({
        row
      }) => [row.write !== 2 ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(row.name), 1)) : (_openBlock(), _createBlock(_component_vxe_input, {
        key: 1,
        modelValue: row.name,
        "onUpdate:modelValue": $event => row.name = $event,
        modelModifiers: {
          trim: true
        },
        maxlenth: "255"
      }, null, 8, ["modelValue", "onUpdate:modelValue"]))]),
      _: 1
    }), _createVNode(_component_vxe_column, {
      field: "image",
      title: "图片",
      width: "100",
      align: "center"
    }, {
      default: _withCtx(({
        row
      }) => [row.write !== 2 ? (_openBlock(), _createBlock(_component_el_image, {
        key: 0,
        src: row.image,
        class: "avatar",
        onMousemove: $event => _ctx.enlarge($event, row),
        onMouseout: $event => _ctx.enlargeOut(row)
      }, {
        error: _withCtx(() => _cache[0] || (_cache[0] = [_createElementVNode("div", {
          class: "image-slot"
        }, [_createElementVNode("i", {
          class: "el-icon-picture-outline"
        })], -1)])),
        _: 2
      }, 1032, ["src", "onMousemove", "onMouseout"])) : (_openBlock(), _createBlock(_component_el_upload, {
        key: 1,
        ref: "uploadRef",
        action: _ctx.data.upLoadUrl,
        "with-credentials": true,
        "on-success": function (res, file, file_list) {
          return _ctx.handleSuccess(res, file, file_list, row);
        },
        "show-file-list": false,
        name: "file",
        limit: 1,
        data: _ctx.data.upLoadQuery,
        accept: ".png, .jpg"
      }, {
        default: _withCtx(() => [row.image ? (_openBlock(), _createBlock(_component_el_image, {
          key: 0,
          src: row.image,
          class: "avatar",
          onMousemove: $event => _ctx.enlarge($event, row),
          onMouseout: $event => _ctx.enlargeOut(row),
          "with-credentials": _ctx.data.withcredentials
        }, {
          error: _withCtx(() => _cache[1] || (_cache[1] = [_createElementVNode("div", {
            class: "image-slot"
          }, [_createElementVNode("i", {
            class: "el-icon-picture-outline"
          })], -1)])),
          _: 2
        }, 1032, ["src", "onMousemove", "onMouseout", "with-credentials"])) : (_openBlock(), _createBlock(_component_el_icon, {
          key: 1,
          class: "el-icon-plus"
        }))]),
        _: 2
      }, 1032, ["action", "on-success", "data"])), _ctx.data.enlargeImg ? _withDirectives((_openBlock(), _createElementBlock("view", {
        key: 2,
        class: "img-show position-f",
        style: _normalizeStyle(_ctx.data.top)
      }, [_createElementVNode("img", {
        src: _ctx.data.enlargeImg
      }, null, 8, _hoisted_2)], 4)), [[_vShow, row.enlargeImgShow]]) : _createCommentVNode("", true)]),
      _: 1
    }), _createVNode(_component_vxe_column, {
      field: "type",
      title: "包装形式",
      "edit-render": {
        autofocus: '.vxe-input--inner'
      },
      width: "250",
      align: "left"
    }, {
      edit: _withCtx(({
        row
      }) => [row.write !== 2 ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(row.type), 1)) : (_openBlock(), _createBlock(_component_vxe_input, {
        key: 1,
        modelValue: row.type,
        "onUpdate:modelValue": $event => row.type = $event,
        modelModifiers: {
          trim: true
        },
        maxlenth: "255"
      }, null, 8, ["modelValue", "onUpdate:modelValue"]))]),
      _: 1
    }), _createVNode(_component_vxe_column, {
      field: "structure",
      title: "包装结构组成",
      "edit-render": {
        autofocus: '.vxe-input--inner'
      },
      width: "250",
      align: "left"
    }, {
      edit: _withCtx(({
        row
      }) => [row.write !== 2 ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(row.structure), 1)) : (_openBlock(), _createBlock(_component_vxe_input, {
        key: 1,
        modelValue: row.structure,
        "onUpdate:modelValue": $event => row.structure = $event,
        modelModifiers: {
          trim: true
        },
        maxlenth: "255"
      }, null, 8, ["modelValue", "onUpdate:modelValue"]))]),
      _: 1
    }), _createVNode(_component_vxe_column, {
      field: "size",
      title: "包装尺寸（不含挂钩尺寸）",
      "edit-render": {
        autofocus: '.vxe-input--inner'
      },
      width: "250",
      align: "left"
    }, {
      edit: _withCtx(({
        row
      }) => [row.write == 0 ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(row.size), 1)) : (_openBlock(), _createBlock(_component_vxe_input, {
        key: 1,
        modelValue: row.size,
        "onUpdate:modelValue": $event => row.size = $event,
        modelModifiers: {
          trim: true
        },
        maxlenth: "255"
      }, null, 8, ["modelValue", "onUpdate:modelValue"]))]),
      _: 1
    }), _createVNode(_component_vxe_column, {
      field: "transport_size",
      title: "运输外箱尺寸",
      "edit-render": {
        autofocus: '.vxe-input--inner'
      },
      width: "250",
      align: "left"
    }, {
      edit: _withCtx(({
        row
      }) => [row.write == 0 ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(row.transport_size), 1)) : (_openBlock(), _createBlock(_component_vxe_input, {
        key: 1,
        modelValue: row.transport_size,
        "onUpdate:modelValue": $event => row.transport_size = $event,
        modelModifiers: {
          trim: true
        },
        maxlenth: "255"
      }, null, 8, ["modelValue", "onUpdate:modelValue"]))]),
      _: 1
    }), _createVNode(_component_vxe_column, {
      field: "layout",
      title: "箱内排布",
      "edit-render": {
        autofocus: '.vxe-input--inner'
      },
      width: "130",
      align: "left"
    }, {
      edit: _withCtx(({
        row
      }) => [row.write == 0 ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(row.layout), 1)) : (_openBlock(), _createBlock(_component_vxe_input, {
        key: 1,
        modelValue: row.layout,
        "onUpdate:modelValue": $event => row.layout = $event,
        modelModifiers: {
          trim: true
        },
        maxlenth: "255"
      }, null, 8, ["modelValue", "onUpdate:modelValue"]))]),
      _: 1
    }), _createVNode(_component_vxe_column, {
      field: "molecule",
      title: "用量（分子）",
      "edit-render": {
        autofocus: '.vxe-input--inner'
      },
      width: "120",
      align: "left"
    }, {
      edit: _withCtx(({
        row
      }) => [_createVNode(_component_vxe_input, {
        modelValue: row.molecule,
        "onUpdate:modelValue": $event => row.molecule = $event,
        type: "number",
        min: "0",
        onBlur: $event => _ctx.checkNum($event, row.index, 'molecule', 8, 4)
      }, null, 8, ["modelValue", "onUpdate:modelValue", "onBlur"])]),
      _: 1
    }), _createVNode(_component_vxe_column, {
      field: "denominator",
      title: "用量（分母）",
      "edit-render": {
        autofocus: '.vxe-input--inner'
      },
      width: "180",
      align: "left"
    }, {
      edit: _withCtx(({
        row
      }) => [_createVNode(_component_vxe_input, {
        modelValue: row.denominator,
        "onUpdate:modelValue": $event => row.denominator = $event,
        type: "number",
        min: "0",
        onBlur: $event => _ctx.checkNum($event, row.index, 'denominator', 8, 4)
      }, null, 8, ["modelValue", "onUpdate:modelValue", "onBlur"])]),
      _: 1
    }), _createVNode(_component_vxe_column, {
      field: "price",
      title: "单价（￥）",
      "edit-render": {
        autofocus: '.vxe-input--inner'
      },
      width: "120",
      align: "left"
    }, {
      edit: _withCtx(({
        row
      }) => [_createVNode(_component_vxe_input, {
        modelValue: row.price,
        "onUpdate:modelValue": $event => row.price = $event,
        type: "number",
        min: "0",
        onBlur: $event => _ctx.checkNum($event, row.index, 'price', 8, 4)
      }, null, 8, ["modelValue", "onUpdate:modelValue", "onBlur"])]),
      _: 1
    }), _createVNode(_component_vxe_column, {
      field: "remark",
      title: "备注",
      "edit-render": {
        autofocus: '.vxe-input--inner'
      },
      width: "250",
      align: "left"
    }, {
      edit: _withCtx(({
        row
      }) => [_createVNode(_component_vxe_input, {
        modelValue: row.remark,
        "onUpdate:modelValue": $event => row.remark = $event,
        modelModifiers: {
          trim: true
        },
        maxlenth: "200"
      }, null, 8, ["modelValue", "onUpdate:modelValue"])]),
      _: 1
    })]),
    _: 1
  }, 8, ["onCheckboxChange", "onCheckboxAll", "checkbox-config", "data"])]);
}